<template>
  <div class="document">
    <div class="header" style="margin-top: 1rem;">
      <EsHeader>
        <template #header>
          <div>Person Details</div>
        </template>
      </EsHeader>
    </div>
    <es-loader v-if="loading" style="margin: 15rem"/>
    <div v-else>
      <div class="content" style="padding: 1rem 0">
        <div class="columns">
          <div class="column master-record--column">
            <es-form style="padding: 1.15rem 0rem; margin: 0rem 1.5rem 0rem 1rem">
              <template #es-form-header>
                <div class="header-container" v-if="anyFieldsEnabled(personInformationFieldNames)">
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'user']" size="lg"/>
                  </div>
                  <div class="header-elements">
                    <h6 class="title">Person Information</h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div v-if="fieldEnabled('FIRST_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('FIRST_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.firstName">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.firstName"
                            :aria-label="fieldLabel('FIRST_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('MIDDLE_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('MIDDLE_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.middleName">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.middleName"
                            :aria-label="fieldLabel('MIDDLE_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('LAST_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('LAST_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.lastName"
                            :aria-label="fieldLabel('LAST_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('SUFFIX')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('SUFFIX') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.suffix">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.suffix"
                            :aria-label="fieldLabel('SUFFIX')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('PREVIOUS_LAST_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('PREVIOUS_LAST_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.previousLastName">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.previousLastName"
                            :aria-label="fieldLabel('PREVIOUS_LAST_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('FULL_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('FULL_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.fullName">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.fullName"
                            :aria-label="fieldLabel('FULL_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('AKA_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('AKA_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.akaName">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.akaName"
                            :aria-label="fieldLabel('AKA_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('GENDER_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('GENDER_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapGender(initialInfo.genderCode)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapGender(initialInfo.genderCode)"
                            :aria-label="fieldLabel('GENDER_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('DATE_OF_BIRTH')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('DATE_OF_BIRTH') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="displayDOBFormat(initialInfo.dateOfBirth)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="displayDOBFormat(initialInfo.dateOfBirth)"
                            :aria-label="fieldLabel('DATE_OF_BIRTH')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('SOCIAL_SECURITY_NUMBER')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('SOCIAL_SECURITY_NUMBER') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.socialSecurityNumber">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.socialSecurityNumber"
                            :aria-label="fieldLabel('SOCIAL_SECURITY_NUMBER')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('ETHNICITY_INDICATOR')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('ETHNICITY_INDICATOR') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapEthnicity(initialInfo.ethnicityIndicator)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapEthnicity(initialInfo.ethnicityIndicator)"
                            :aria-label="fieldLabel('ETHNICITY_INDICATOR')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RACE_ETHNIC_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RACE_ETHNIC_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo && initialInfo.raceEthnicCode
                              && initialInfo.raceEthnicCode.length
                                ? mapRace(initialInfo.raceEthnicCode) : '--'">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo && initialInfo.raceEthnicCode
                              && initialInfo.raceEthnicCode.length
                                ? mapRace(initialInfo.raceEthnicCode) : '--'"
                            :aria-label="fieldLabel('RACE_ETHNIC_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RACE2_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RACE2_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="(initialInfo && initialInfo.race2Code
                              && initialInfo.race2Code.length
                                ? mapRace(initialInfo.race2Code) : '--')">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo && initialInfo.race2Code
                              && initialInfo.race2Code.length
                                ? mapRace(initialInfo.race2Code) : '--'"
                            :aria-label="fieldLabel('RACE2_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RACE3_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RACE3_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="(initialInfo && initialInfo.race3Code
                              && initialInfo.race3Code.length
                                ? mapRace(initialInfo.race3Code) : '--')">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo && initialInfo.race3Code
                              && initialInfo.race3Code.length
                                ? mapRace(initialInfo.race3Code) : '--'"
                            :aria-label="fieldLabel('RACE3_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RACE4_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RACE4_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="(initialInfo && initialInfo.race4Code
                              && initialInfo.race4Code.length
                                ? mapRace(initialInfo.race4Code) : '--')">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo && initialInfo.race4Code
                              && initialInfo.race4Code.length
                                ? mapRace(initialInfo.race4Code) : '--'"
                            :aria-label="fieldLabel('RACE4_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RACE5_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RACE5_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="(initialInfo && initialInfo.race5Code
                              && initialInfo.race5Code.length
                                ? mapRace(initialInfo.race5Code) : '--')">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo && initialInfo.race5Code
                              && initialInfo.race5Code.length
                                ? mapRace(initialInfo.race5Code) : '--'"
                            :aria-label="fieldLabel('RACE5_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('ETHNIC_SUB_GROUP')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('ETHNIC_SUB_GROUP') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapEthnicSubGroup(initialInfo.ethnicSubGroup)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapEthnicSubGroup(initialInfo.ethnicSubGroup)"
                            :aria-label="fieldLabel('ETHNIC_SUB_GROUP')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('STATE_STUDENT_ID')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('STATE_STUDENT_ID') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="(formatStateID(initialInfo.stateStudentId
                              ? initialInfo.stateStudentId : initialInfo.personId))">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="formatStateID(initialInfo.stateStudentId
                              ? initialInfo.stateStudentId : initialInfo.personId)"
                            :aria-label="fieldLabel('STATE_STUDENT_ID')"
                          />
                        </div>
                        <span
                          v-if="$route.path.includes('mergedRecordDetails') && !isRetired"
                          class="retired"
                        >
                          RETIRED
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </es-form>
          </div>
          <div class="column master-record--column border-left">
            <es-form style="padding: 1.15rem 0.5rem; margin: 0rem 1.5rem 0rem 1rem">
              <template #es-form-header>
                <div v-if="anyFieldsEnabled(contactInformationFieldNames)" class="header-container">
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'address-book']" size="lg" />
                  </div>
                  <div class="header-elements">
                    <h6 class="title">Contact Information</h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div v-if="fieldEnabled('STREET_1')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('STREET_1') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.street1">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.street1"
                            :aria-label="fieldLabel('STREET_1')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('STREET_2')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('STREET_2') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.street2">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.street2"
                            :aria-label="fieldLabel('STREET_2')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('CITY')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('CITY') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.city">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.city"
                            :aria-label="fieldLabel('CITY')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('STATE_CODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('STATE_CODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapState(initialInfo.stateCode)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapState(initialInfo.stateCode)"
                            :aria-label="fieldLabel('STATE_CODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('ZIP')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('ZIP') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.zip">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.zip"
                            :aria-label="fieldLabel('ZIP')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('GEOCODE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('GEOCODE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.geocode">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.geocode"
                            :aria-label="fieldLabel('GEOCODE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </es-form>
            <es-form style="padding: 1.15rem 0.5rem; margin: 0rem 1.5rem 0rem 1rem">
              <template #es-form-header>
                <div
                  v-if="anyFieldsEnabled(credentialInformationFieldNames)"
                  class="header-container"
                >
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'diploma']" size="lg"/>
                  </div>
                  <div class="header-elements">
                    <h6 class="title">Credential Information</h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div v-if="fieldEnabled('HIGHEST_DEGREE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('HIGHEST_DEGREE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapHighestDegree(initialInfo.highestDegree)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapHighestDegree(initialInfo.highestDegree)"
                            :aria-label="fieldLabel('HIGHEST_DEGREE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('SUBJECT_MATTER_AREA')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('SUBJECT_MATTER_AREA') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapSubjectMatterArea(initialInfo.subjectMatterArea)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapSubjectMatterArea(initialInfo.subjectMatterArea)"
                            :aria-label="fieldLabel('SUBJECT_MATTER_AREA')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('DEGREE_PROVIDER')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('DEGREE_PROVIDER') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.degreeProvider">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.degreeProvider"
                            :aria-label="fieldLabel('DEGREE_PROVIDER')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('CERTIFICATE_NUMBER')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('CERTIFICATE_NUMBER') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.certificateNumber">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.certificateNumber"
                            :aria-label="fieldLabel('CERTIFICATE_NUMBER')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('CERTIFICATE_TYPE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('CERTIFICATE_TYPE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapCertificateType(initialInfo.certificateType)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapCertificateType(initialInfo.certificateType)"
                            :aria-label="fieldLabel('CERTIFICATE_TYPE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </es-form>
          </div>
          <div class="column master-record--column border-left">
            <es-form style="padding: 1.15rem 0.5rem; margin: 0rem 1.5rem 0rem 1rem">
              <template #es-form-header>
                <div v-if="anyFieldsEnabled(otherInformationFieldNames)" class="header-container">
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'list-alt']" size="lg"/>
                  </div>
                  <div class="header-elements">
                    <h6 class="title">Other Information</h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div v-if="fieldEnabled('BIRTH_LOCATION')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('BIRTH_LOCATION') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.birthLocation">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.birthLocation"
                            :aria-label="fieldLabel('BIRTH_LOCATION')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RESIDENCY_STATUS')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RESIDENCY_STATUS') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="mapResidencyStatus(initialInfo.residencyStatus)">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="mapResidencyStatus(initialInfo.residencyStatus)"
                            :aria-label="fieldLabel('RESIDENCY_STATUS')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('RESIDENCY_EXPIRATION_DATE')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('RESIDENCY_EXPIRATION_DATE') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.residencyExpirationDate | formatDateMMDDYYYY">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.residencyExpirationDate | formatDateMMDDYYYY"
                            :aria-label="fieldLabel('RESIDENCY_EXPIRATION_DATE')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('MOTHERS_MAIDEN_NAME')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('MOTHERS_MAIDEN_NAME') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.mothersMaidenName">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.mothersMaidenName"
                            :aria-label="fieldLabel('MOTHERS_MAIDEN_NAME')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </es-form>
            <es-form style="padding: 1.15rem 0.5rem; margin: 0rem 1.5rem 0rem 1rem">
              <template #es-form-header>
                <div
                  v-if="anyFieldsEnabled(cdfFieldNames)"
                  class="header-container"
                >
                  <div class="header-elements">
                    <font-awesome-icon
                      :icon="['fas', 'database']"
                      size="lg"
                    />
                  </div>
                  <div class="header-elements">
                    <h6 class="title">
                      Customer Defined Fields
                    </h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div
                  v-if="fieldEnabled('cdf_1')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('cdf_1') }}
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_1">
                            <input
                              class="input is-static no-pointer"
                              type="text"
                              :value="initialInfo.studentCdf.cdf_1"
                              readonly
                              :aria-label="fieldLabel('cdf_1')"
                            >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_2')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_2') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_2">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_2"
                            :aria-label="fieldLabel('cdf_2')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_3')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_3') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_3">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_3"
                            :aria-label="fieldLabel('cdf_3')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_4')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_4') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_4">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_4"
                            :aria-label="fieldLabel('cdf_4')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_5')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_5') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_5">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_5"
                            :aria-label="fieldLabel('cdf_5')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_6')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_6') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_6">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_6"
                            :aria-label="fieldLabel('cdf_6')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_7')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_7') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_7">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_7"
                            :aria-label="fieldLabel('cdf_7')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_8')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_8') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_8">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_8"
                            :aria-label="fieldLabel('cdf_8')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_9')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_9') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_9 | formatDateMMDDYYYY">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_9 | formatDateMMDDYYYY"
                            :aria-label="fieldLabel('cdf_9')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_10')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_10') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_10">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_10"
                            :aria-label="fieldLabel('cdf_10')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fieldEnabled('cdf_11')" class="row">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">{{ fieldLabel('cdf_11') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" :title="initialInfo.studentCdf.cdf_11">
                          <input
                            class="input is-static no-pointer"
                            type="text"
                            readonly
                            :value="initialInfo.studentCdf.cdf_11"
                            :aria-label="fieldLabel('cdf_11')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </es-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
} from '@fortawesome/pro-regular-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import StateIdUtils from '@/mixins/StateIdUtils';

library.add(
  faEdit,
);

export default {
  mixins: [
    DateUtils,
    FieldLabels,
    NotificationManager,
    PermissionManager,
    StateIdUtils,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsHeader,
    EsLoader,
  },
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.onLoad();
    this.initialInfo = JSON.parse(JSON.stringify(this.person));
  },
  data() {
    return this.initialData();
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeGenders',
      'activeStates',
      'activeRaces',
      'activeEthnicities',
      'activeEthnicSubGroups',
      'activeResidencyStatuses',
      'activeStates',
      'activeHighestDegrees',
      'activeSubjectMatterAreas',
      'activeCertificateTypes',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
      'getFieldEnabledForPersonType',
      'getFieldRequiredForPersonType',
    ]),
    cdfFieldNames() {
      return ['cdf_1',
        'cdf_2',
        'cdf_3',
        'cdf_4',
        'cdf_5',
        'cdf_6',
        'cdf_7',
        'cdf_8',
        'cdf_9',
        'cdf_10',
        'cdf_11',
      ];
    },
    contactInformationFieldNames() {
      return ['STREET_1',
        'STREET_2',
        'CITY',
        'STATE_CODE',
        'ZIP',
        'GEOCODE',
      ];
    },
    credentialInformationFieldNames() {
      return ['HIGHEST_DEGREE',
        'SUBJECT_MATTER_AREA',
        'DEGREE_PROVIDER',
        'CERTIFICATE_NUMBER',
        'CERTIFICATE_TYPE',
      ];
    },
    otherInformationFieldNames() {
      return ['BIRTH_LOCATION',
        'RESIDENCY_STATUS',
        'RESIDENCY_EXPIRATION_DATE',
        'MOTHERS_MAIDEN_NAME',
      ];
    },
    personInformationFieldNames() {
      return ['FIRST_NAME',
        'MIDDLE_NAME',
        'LAST_NAME',
        'SUFFIX',
        'PREVIOUS_LAST_NAME',
        'AKA_NAME',
        'GENDER_CODE',
        'DATE_OF_BIRTH',
        'SOCIAL_SECURITY_NUMBER',
        'ETHNICITY_INDICATOR',
        'RACE_ETHNIC_CODE',
        'RACE2_CODE',
        'RACE3_CODE',
        'RACE4_CODE',
        'RACE5_CODE',
        'ETHNIC_SUB_GROUP',
        'STATE_STUDENT_ID',
      ];
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadGenders',
      'loadStates',
      'loadRaces',
      'loadEthnicities',
      'loadEthnicSubGroups',
      'loadGrades',
      'loadPersonTypes',
      'loadResidencyStatuses',
      'loadHighestDegrees',
      'loadSubjectMatterAreas',
      'loadCertificateTypes',
    ]),
    anyFieldsEnabled(fieldNames) {
      // check whether any field is enabled
      const items = fieldNames.filter(fn => this.fieldEnabled(fn));
      return (items && items.length > 0);
    },
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, 'ASSIGN', this.person.personType);
    },
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.person.personType);
    },
    initialData() {
      return {
        initialInfo: {},
        loading: false,
        loadingError: false,
      };
    },
    mapCertificateType() {
      const item = this.activeCertificateTypes
        .find(e => e.code === this.initialInfo.certificateType);
      return item ? item.description : '\u00A0';
    },
    mapEthnicity() {
      const item = this.activeEthnicities
        .find(e => e.code === this.initialInfo.ethnicityIndicator);
      return item ? item.description : '\u00A0';
    },
    mapEthnicSubGroup(ethnicSubGroup) {
      const item = this.activeEthnicSubGroups
        .find(e => e.code === ethnicSubGroup);
      return item ? item.description : '\u00A0';
    },
    mapGender() {
      const item = this.activeGenders
        .find(g => g.code === this.initialInfo.genderCode);
      return item ? item.description : '\u00A0';
    },
    mapHighestDegree() {
      const item = this.activeHighestDegrees
        .find(d => d.code === this.initialInfo.highestDegree);
      return item ? item.description : '\u00A0';
    },
    mapRace(race) {
      const item = this.activeRaces.find(r => r.code === race);
      return item ? item.description : '\u00A0';
    },
    mapResidencyStatus() {
      const item = this.activeResidencyStatuses
        .find(r => r.code === this.initialInfo.residencyStatus);
      return item ? item.description : '\u00A0';
    },
    mapState() {
      const item = this.activeStates
        .find(s => s.code === this.initialInfo.stateCode);
      return item ? item.description : '\u00A0';
    },
    mapSubjectMatterArea() {
      const item = this.activeSubjectMatterAreas
        .find(s => s.code === this.initialInfo.subjectMatterArea);
      return item ? item.description : '\u00A0';
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadPersonTypes(),
          this.loadResidencyStatuses(),
          this.loadStates(),
          this.loadHighestDegrees(),
          this.loadSubjectMatterAreas(),
          this.loadCertificateTypes(),
          this.loadEthnicSubGroups(),
        ]);
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .action-buttons
    border-top: 1px solid #dee2e6;
    margin: 0rem 2rem !important
    padding: 1rem 2rem 1rem 0rem !important
  .border-left
    border-left: 1px solid #dee2e6;
  .columns
    padding-left: 2rem
    padding-top: 2rem
    display: flex
    flex-wrap: wrap
  .column
    padding: 0
    flex: 1 0 auto
  .row .field
    display: flex
    align-items: center
    gap: 0.5rem;
    .field-label
      white-space: nowrap
      margin-right: 0
    .field-body
      flex: 1 0 auto
      .control
        width: 100%
      input
        width: 100%
        text-overflow: ellipsis
  .header
    display: flex
    align-items: center
  .icon-right
    padding-right: 1rem
  .input
    padding-top: 0 !important
  .no-pointer
    pointer-events: none
    &:hover
      text-decoration:  none
  .padding--1rem
    padding: 1rem
  .reason-header
    color: #555555
    font-size: 13.6px
    font-weight: 700
    text-align: left
    padding-left: 1rem
  .reason-text
    color: #212529
    font-size: 13.6px
    font-weight: 400
    text-align: left
    padding-left: 1rem
  .retired
    color: #ffc107 !important
    font-size: 12px !important
    font-weight: 700 !important
  .retiredId
    color: #999999
    font-size: 13.6px
    font-weight: 400
  .field
    display: flex
  @media screen and (max-width: 70em)
    .columns
      display: block
      .column
        width: 100%
        border-left: none
</style>
